module.exports = __webpack_public_path__ + "img/sample1.c50b20c7.jpg";